<template>
  <div class="">
    <el-form
      :model="newDomain"
      :rules="rules"
      ref="form"
      hide-required-asterisk
      label-position="top"
      class="brand-input brand-validation"
      @submit.prevent.native="submit()"
    >
      <div class="px-8 pt-6 pb-6">
        <p class="text-xl font-bold mb-4 text-brand-black">Add Email Sender Domain</p>
        <p class="text-sm font-medium text-brand-brown mb-4">
          This will allow you to send email from <strong>@{{ newDomain.url || 'yourdomain.com' }}</strong> addresses.
        </p>
        <el-form-item prop="url" label="Domain name" class="font-bold text-left pb-2">
          <el-input placeholder="yourdomain.com" type="text" v-model="newDomain.url">
            <template slot="prepend">@</template>
          </el-input>
        </el-form-item>
        <el-collapse v-model="showBounce">
          <el-collapse-item title="Advanced options" name="returnPath">
            <el-form-item prop="returnPath" class="font-bold px-2 pt-2 pb-2" label="Bounce Address (Return Path)">
              <el-input type="text" placeholder="bounces" v-model="newDomain.returnPath" class="text-right">
                <template slot="prepend">https://</template>
                <template slot="append">.{{ newDomain.url || 'yourdomain.com' }}</template>
              </el-input>
            </el-form-item>
            <p class="text-sm text-brand-brown mt-2 mb-4 font-medium">
              This is a subdomain that you use to process bounced messages. It helps compartmentalize bounces. But for our purposes, it boosts
              reputation in the eyes of email vendors.
              <a
                class="text-brand-blue font-semibold"
                target="_blank"
                href="https://postmarkapp.com/blog/how-dmarc-and-a-custom-return-path-work-together"
                >Learn more -></a
              >
            </p>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- Cancel / Submit-->
      <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-4 rounded-b-lg">
        <el-button
          @click="
            resetForm();
            close();
          "
          type="plain"
          class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg"
        >
          <span class="text-sm text-brand-blue font-semibold">Nevermind</span>
        </el-button>
        <el-button native-type="submit" type="primary" class="font-bold py-2 px-6 rounded-lg text-sm" :loading="isLoading"
          >Add Sender Domain</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
const rules = {
  url: [{ required: true, message: 'Domain name is required', trigger: 'blur' }],
  returnPath: [{ required: true, message: 'Return path is required', trigger: 'blur' }],
};

export default {
  data() {
    return {
      showBounce: [],
      isLoading: false,
      newDomain: {
        returnPath: 'ck-bounces',
        url: '',
      },
      rules,
    };
  },
  props: {
    close: {
      type: Function,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    async submit() {
      if (!this.$refs.form) return;
      await this.$refs.form.validate((valid, fields) => {
        if (valid) {
          this.addDomainName();
        } else if (Object.keys(fields).includes('returnPath')) {
          this.showBounce = ['returnPath'];
        }
      });
    },
    async addDomainName() {
      try {
        this.isLoading = true;
        const protocol = new RegExp('^(http|https)://', 'i');
        const senderDomain = this.newDomain.url.replace(protocol, '');
        const returnPath = `${this.newDomain.returnPath}.${senderDomain}`;
        await this.action({ senderDomain, returnPath });
        this.close();
        this.isLoading = false;
        this.resetForm();
      } catch (error) {
        console.log(error);
        this.error = error;
      }
    },
  },
};
</script>

<style>
.el-collapse-item__content {
  padding-bottom: 0px;
}
</style>
